import React from 'react';
import './Boost.scss';

export default function Boost() {
  return (
    <section className='boost'>
      <h2>Boost your links today</h2>
      <button className='btn not-active'>Get Started</button>
    </section>
  );
}
